import  React from 'react';
import Modal from '../../common/modal';
import NewClaimModalContent from './newClaimModalContent'; 

const NewClaimModal = (props) => {
     return (
            <Modal title="Transaction Details" isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
                <NewClaimModalContent 
                    transaction={props.transaction} 
                    closeModal={props.onRequestClose} 
                    />
            </Modal>
       )
}

export default NewClaimModal;


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/newClaim/newClaimModal.js